import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useLanguage } from '../i18n/LanguageContext';
import { getApiBase } from '../utils/runtime';

function WaitingListDecline() {
  const { request_id } = useParams();
  const navigate = useNavigate();
  const { isEnglish } = useLanguage();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const declineRequest = async () => {
      try {
        const res = await axios.post(
          `${getApiBase()}/waiting-list/${request_id}/decline`
        );
        setMessage(res.data.message || (isEnglish ? 'You declined the proposed time slot.' : 'Vous avez bien refuse le creneau propose.'));
        setLoading(false);

        setTimeout(() => navigate('/patient/dashboard'), 5000);
      } catch (err) {
        console.error('Error while declining waitlist slot:', err);
        setError(
          err?.response?.data?.error ||
          (isEnglish ? 'Something went wrong. Please try again later.' : 'Une erreur est survenue. Merci de reessayer plus tard.')
        );
        setLoading(false);
      }
    };

    declineRequest();
  }, [request_id, navigate, isEnglish]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      {loading && <p>{isEnglish ? 'Updating your response...' : 'Traitement du refus en cours...'}</p>}
      {message && <p style={{ color: 'orange', fontWeight: 'bold' }}>{message}</p>}
      {error && <p style={{ color: 'red', fontWeight: 'bold' }}>{error}</p>}
    </div>
  );
}

export default WaitingListDecline;
